import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=03ebce5c"
import script from "./AccountMenu.vue?vue&type=script&lang=ts"
export * from "./AccountMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports